import { Favorite, PriceTracking, PriceHistory } from '../types';
import { getFavorites, getPriceTracking, getPriceHistory } from './storage';

export interface ExportData {
  favorites: Favorite[];
  priceTracking: (PriceTracking & { history: PriceHistory[] })[];
  exportedAt: string;
  exportVersion: string;
}

/**
 * Export all user data as JSON
 */
export async function exportUserData(): Promise<ExportData> {
  const favorites = await getFavorites();
  const tracking = await getPriceTracking();
  
  // Get price history for each tracking item
  const trackingWithHistory = await Promise.all(
    tracking.map(async (track) => {
      const history = await getPriceHistory(track.id);
      return {
        ...track,
        history,
      };
    })
  );

  return {
    favorites,
    priceTracking: trackingWithHistory,
    exportedAt: new Date().toISOString(),
    exportVersion: '1.0',
  };
}

/**
 * Download data as JSON file
 */
export function downloadExport(data: ExportData, filename: string = 'dryv-export.json'): void {
  const json = JSON.stringify(data, null, 2);
  const blob = new Blob([json], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/**
 * Export and download user data
 */
export async function exportAndDownloadData(): Promise<void> {
  try {
    const data = await exportUserData();
    const timestamp = new Date().toISOString().split('T')[0];
    downloadExport(data, `dryv-export-${timestamp}.json`);
  } catch (error) {
    console.error('Error exporting data:', error);
    throw new Error('Failed to export data');
  }
}

